export default __webpack_public_path__ + "static/media/plates.1f5e38f4.png";